export default from './new-post-message';



// WEBPACK FOOTER //
// ./app/components/new-post-message/index.js